import axios from "axios";
import { loginFailure, loginStart, loginSuccess } from "./AuthActions";
import { apiUrl } from "../../config";

export const login = async (user, dispatch) => {
	dispatch(loginStart());

	try {
		const res = await axios.post(apiUrl + "/user/authenticate", user);
		dispatch(loginSuccess(res.data))
	} catch (error) {
		dispatch(loginFailure(error.response?.data || error.message));
	}
};